/** The three private Supabase Storage buckets. Mirrors the CHECK on assets.bucket. */
export enum AssetBucket {
  SourceDocuments = 'source-documents',
  QuestionAssets = 'question-assets',
  ResponseFiles = 'response-files',
}
